import getCdnUrl from '../../../helpers/get-cdn-url';

const FingoWatermarkLogo = getCdnUrl('/logos/fingo-watermark.webp');

export default FingoWatermarkLogo;
